import {
  oneFreeMonth1Image,
  oneFreeMonth2Image,
  oneFreeMonth3Image,
  oneFreeMonth4Image,
} from '@src/assets/images';

export const ONE_FREE_MONTH_SLIDES: {
  id: number;
  title: string;
  description: string;
  image: string;
}[] = [
  oneFreeMonth1Image,
  oneFreeMonth2Image,
  oneFreeMonth3Image,
  oneFreeMonth4Image,
].map((image, i) => ({
  id: i + 1,
  title: `oneFreeMonth.slides.${i + 1}.title`,
  description: `oneFreeMonth.slides.${i + 1}.description`,
  image,
}));

export const CANCELLATION_REASON_KEY = {
  FORGET_TO_CANCEL: 'forget_to_cancel',
  TOO_EXPENSIVE: 'too_expensive',
  NO_TIME: 'no_time',
  NO_NEED: 'no_need',
  NOT_ENJOYING_PLAN: 'not_enjoying_plan',
  NOT_MEET_EXPECTATIONS: 'not_meet_expectations',
  CANT_LOGIN: 'cant_login',
  OTHER: 'other',
} as const;
